import { CreateAvatarStoreProvider } from '@/pages/avatar/common/context';
import { AvatarType } from '@/pages/avatar/common/types';
import { AvatarPage } from './AvatarPage';

export const PremiumPlusAvatarCreatePage = () => {
    return (
        <CreateAvatarStoreProvider type={AvatarType.PremiumPlus}>
            <AvatarPage />
        </CreateAvatarStoreProvider>
    );
};
